import React, { useEffect, useRef, useState } from "react";
import { InteractionType } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from "@azure/msal-react";

import NetworkInterceptor from "./apis/NetworkInterceptor";
import { loginRequest } from "./authConfig";
import { useAddToast } from "@hm-group/bads-react";
import "./App.scss";
import TopBarHeader from "./components/TopBarHeader/TopBarHeader";
import Content from "./components/ContentView/ContentView";
import { NavigationTabs } from "./constants/constants";

const App: React.FC = () => {
  useMsalAuthentication(InteractionType.Redirect, loginRequest);

  const searchParams = new URLSearchParams(document.location.search);
  const params = new URLSearchParams(Array.from(searchParams));
  const productDevIdFromParams = params.get("productDevId") || "";
  const seasonNumberFromParams = params.get("seasonNumber") || "";
  const [activeTab, setActiveTab] = useState(NavigationTabs.ProductTaxonomy);
  const { addToast } = useAddToast();
  const hasShownToastRef = useRef(false);
  useEffect(() => {
    if (hasShownToastRef.current) return;
    if (!productDevIdFromParams || !seasonNumberFromParams) {
      addToast({
        title: "Missing Parameters",
        subtitle: "Product Dev ID and/or Season Number is missing in the URL.",
        type: "error",
      });
      hasShownToastRef.current = true;
    }
  }, []);

  return (
    <div className="App">
      <AuthenticatedTemplate>
        <NetworkInterceptor>
          <div>
            <TopBarHeader
              activeTab={activeTab}
              onTabChange={setActiveTab}
            ></TopBarHeader>
            <Content
              activeTab={activeTab}
              productDevIdFromParams={productDevIdFromParams}
              seasonNumberFromParams={seasonNumberFromParams}
            ></Content>
          </div>
        </NetworkInterceptor>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div>Signing In.....</div>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default App;
